export default __webpack_public_path__ + "static/media/DIN Condensed Bold.4cb4db43.ttf";